import { matchPath } from "react-router-dom";

export const isCLevelPath = (pathname: string) =>
  Boolean(matchPath({ path: "/services/c-level", end: true }, pathname));
